<template>
  <div class="Container">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'Container',
  }
</script>

<style scoped>
  .Container {
    padding: 72px 18px;
    flex: 1 0;
    display: flex;
    justify-content: center;
  }
</style>